import { render } from "./VLoader.vue?vue&type=template&id=eb09532a&scoped=true"
import script from "./VLoader.vue?vue&type=script&lang=js"
export * from "./VLoader.vue?vue&type=script&lang=js"

import "./VLoader.vue?vue&type=style&index=0&id=eb09532a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb09532a"]])

export default __exports__